import type { Environment } from './environment.model';

export const baseEnvironment: Omit<Environment, 'production' | 'apiUrl'> = {
  appName: 'MyApp',
  version: '1.0.0',
  encrypt: false,
  secretKey: '6w08dR8O6KRyIxbc0BxVr6i6kx1XYyXvIepV9ej7rAB6SiArQE',
};
